<mat-dropdown
  [formControl]="formAssociation.formControl"
  [options]="formAssociation.options"
  [configurationInput]="formAssociation.configurationInput"
  [isFormSubmitted]="isFormSubmitted"
></mat-dropdown>

<ng-container *ngFor="let key of enumValues">
  <div *ngIf="childDropdowns[key] as item">
    <mat-dropdown
      [formControl]="item.formControl"
      [options]="item.options"
      [configurationInput]="item.configurationInput"
      [isFormSubmitted]="isFormSubmitted"
      (search)="item?.loadFn?.($event)"
    >
    </mat-dropdown>
  </div>
</ng-container>
